window.lazyImages = [];

window.observeLazyImages = function() {
  if (window.lazyImageObserver) window.lazyImageObserver.disconnect();

  if ("IntersectionObserver" in window) {
    window.lazyImageObserver = new IntersectionObserver(function(
      entries,
      observer
    ) {
      var visibilityChanged = false;
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          visibilityChanged = true;
          var lazyImage = entry.target;
          if (lazyImage.dataset.src) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.addEventListener("load", function() {
              window.dispatchEvent(new Event("lazy-images:loaded"));
            });
            delete lazyImage.dataset.src;
          }
          if (lazyImage.dataset.srcset) {
            lazyImage.srcset = lazyImage.dataset.srcset;
            delete lazyImage.dataset.srcset;
          }
          lazyImageObserver.unobserve(lazyImage);
          window.lazyImages = window.lazyImages.filter(el => el !== lazyImage);
        }
      });

      if (visibilityChanged) {
        window.dispatchEvent(new Event("lazy-images:loaded"));
      }
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    lazyImages.forEach(function(lazyImage) {
      lazyImage.src = lazyImage.dataset.src;
      lazyImage.srcset = lazyImage.dataset.srcset;
    });
  }
};

window.updateLazyImages = function() {
  [].slice
    .call(document.querySelectorAll("img[data-src]"))
    .filter(el => !window.lazyImages.includes(el))
    .forEach(el => {
      window.lazyImages.push(el);
    });

  observeLazyImages();
};

window.updateLazyImages();
document.addEventListener("DOMContentLoaded", function() {
  window.updateLazyImages();
});
document.addEventListener("ready", function() {
  window.updateLazyImages();
});
